"use strict";

var cov_1rfb7233vj = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\TextObject.js";
  var hash = "876beb01b729cb8e4ad283da18541b6539323ae0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\TextObject.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 16
        },
        end: {
          line: 8,
          column: 76
        }
      },
      "1": {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 15,
          column: 4
        }
      },
      "2": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 13,
          column: 86
        }
      },
      "3": {
        start: {
          line: 11,
          column: 52
        },
        end: {
          line: 11,
          column: 101
        }
      },
      "4": {
        start: {
          line: 12,
          column: 9
        },
        end: {
          line: 13,
          column: 86
        }
      },
      "5": {
        start: {
          line: 12,
          column: 26
        },
        end: {
          line: 12,
          column: 74
        }
      },
      "6": {
        start: {
          line: 13,
          column: 9
        },
        end: {
          line: 13,
          column: 86
        }
      },
      "7": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 17
        }
      },
      "8": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 21,
          column: 4
        }
      },
      "9": {
        start: {
          line: 24,
          column: 0
        },
        end: {
          line: 32,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "TextObject",
        decl: {
          start: {
            line: 4,
            column: 9
          },
          end: {
            line: 4,
            column: 19
          }
        },
        loc: {
          start: {
            line: 7,
            column: 3
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 25
          },
          end: {
            line: 9,
            column: 26
          }
        },
        loc: {
          start: {
            line: 9,
            column: 42
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 17
          },
          end: {
            line: 8,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 17
          },
          end: {
            line: 8,
            column: 33
          }
        }, {
          start: {
            line: 8,
            column: 37
          },
          end: {
            line: 8,
            column: 57
          }
        }, {
          start: {
            line: 8,
            column: 61
          },
          end: {
            line: 8,
            column: 63
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 13,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 13,
            column: 86
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 13,
            column: 86
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 8
          },
          end: {
            line: 11,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 8
          },
          end: {
            line: 11,
            column: 18
          }
        }, {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 50
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 13,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 13,
            column: 86
          }
        }, {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 13,
            column: 86
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "876beb01b729cb8e4ad283da18541b6539323ae0"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function TextObject(_ref) {
  var verseObject = _ref.verseObject,
      paragraphs = _ref.paragraphs;
  cov_1rfb7233vj.f[0]++;
  var lines = (cov_1rfb7233vj.s[0]++, ((cov_1rfb7233vj.b[0][0]++, verseObject.text) || (cov_1rfb7233vj.b[0][1]++, verseObject.nextChar) || (cov_1rfb7233vj.b[0][2]++, '')).split('\n'));
  var text = (cov_1rfb7233vj.s[1]++, lines.map(function (line, index) {
    cov_1rfb7233vj.f[1]++;

    var _line;

    cov_1rfb7233vj.s[2]++;

    if ((cov_1rfb7233vj.b[2][0]++, paragraphs) && (cov_1rfb7233vj.b[2][1]++, index === lines.length - 1)) {
      cov_1rfb7233vj.b[1][0]++;
      cov_1rfb7233vj.s[3]++;
      _line = _react.default.createElement(_react.Fragment, {
        key: index
      }, line, " ");
    } else {
      cov_1rfb7233vj.b[1][1]++;
      cov_1rfb7233vj.s[4]++;

      if (index === 0) {
        cov_1rfb7233vj.b[3][0]++;
        cov_1rfb7233vj.s[5]++;
        _line = _react.default.createElement(_react.Fragment, {
          key: index
        }, line);
      } else {
        cov_1rfb7233vj.b[3][1]++;
        cov_1rfb7233vj.s[6]++;
        _line = _react.default.createElement(_react.Fragment, {
          key: index
        }, [_react.default.createElement("br", {
          key: Math.random()
        }), line]);
      }
    }

    cov_1rfb7233vj.s[7]++;
    return _line;
  }));
  cov_1rfb7233vj.s[8]++;
  return _react.default.createElement(_react.default.Fragment, null, text);
}

;
cov_1rfb7233vj.s[9]++;
TextObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string
  }).isRequired,

  /** render verses paragraphs, use explicit paragraphs */
  paragraphs: _propTypes.default.bool
};
var _default = TextObject;
exports.default = _default;